import React from 'react';
import propTypes from 'prop-types';

import './Loader.scss';

const Loader = (props) => (
  <div
    className={`spinner ${props.theme || ''}`}
    style={{
      width: props?.width,
      height: props?.height,
      margin: props?.margin,
    }}
  >
    <div className="double-bounce1" />
    <div className="double-bounce2" />
  </div>
);

Loader.defaultProps = { theme: '' };

Loader.propTypes = {
  /** Loader Theme */
  width: propTypes.any,
  theme: propTypes.string,
  height: propTypes.any,
  margin: propTypes.any,
};

export default Loader;
